/**
 * verification-api-serverless wrappers for DM persona login.
 *
 * Flow:
 *   1. requestEmailCode(email) → POST /api/v0/verification/request → returns { id }
 *      The user receives a 6-digit code by email.
 *   2. verifyEmailCode(id, code) → POST /api/v0/verification/code → returns { status }
 *      `status === 200` → no auths_beta row exists yet → proceed to signup
 *      `status === 201` → user exists → proceed to login
 */

import { dmRequest, DM_ENV } from './dmApiClient';

const TYPE_LOGIN_OR_SIGNUP = 1;
const METHOD_EMAIL = 1;

const API_PREFIX = '/api/v0';

export async function requestEmailCode(email) {
  const res = await dmRequest(DM_ENV.verificationApiBase, `${API_PREFIX}/verification/request`, {
    method: 'POST',
    body: {
      type: TYPE_LOGIN_OR_SIGNUP,
      user_data: email,
      method: METHOD_EMAIL,
    },
  });
  const data = res?.data || {};
  return {
    verificationId: data.id,
    resendStatus: Boolean(data.resend_status),
    raw: res,
  };
}

export async function verifyEmailCode(verificationId, code) {
  const res = await dmRequest(DM_ENV.verificationApiBase, `${API_PREFIX}/verification/code`, {
    method: 'POST',
    body: { id: verificationId, code },
  });
  const data = res?.data || {};
  return {
    status: data.status,
    retry: typeof data.retry === 'number' ? data.retry : 0,
    raw: res,
  };
}
